import { ITimer, ITimerState } from 'entities/Timer/Timer.models';

export const timerReducers = {
  setTimer: (state: ITimerState, payload: ITimer) => ({ ...state, data: payload }),
  setLoading: (state: ITimerState, payload: boolean) => ({ ...state, loading: payload }),
  setIsRunning: (state: ITimerState, payload: boolean) => ({ ...state, isRunning: payload }),
  setUntrackedTime: (state: ITimerState, payload: number) => ({ ...state, untrackedTime: payload }),
  clearTimer: (state: ITimerState) => ({ ...state, data: null, isRunning: false, untrackedTime: 0 }),
};
